import {COLORS} from "./colors-ts";
import type {ThemeOptions} from "@mui/material";
import {createTheme, unstable_createMuiStrictModeTheme} from "@mui/material";
import {environment} from "../env";

// @see: https://material-ui.com/customization/default-theme/
export const theme: ThemeOptions = {
    palette: {...COLORS},
    typography: {
        fontSize: 14,
        h1: {
            fontSize: '6rem',
        },
        h2: {
            // Page title
            fontSize: '3.75rem',
        },
        h3: {
            fontSize: '3rem',
        },
        body1: {
            fontSize: '1rem',
        },
        body2: {
            fontSize: '0.875rem',
        },
    },
    // spacing = N * 8px (https://material-ui.com/customization/spacing/)
};

// const v4Theme = adaptV4Theme(theme)
export const _theme = environment.production ? createTheme(theme) : unstable_createMuiStrictModeTheme(theme);
